import { createFileRoute } from '@tanstack/react-router';

// relative imports
import TirFilesTable from '../../../components/file-management/file-management-table/TirFilesTable';
import Loader from '../../../components/shared/custom-components/Loader';

export const Route = createFileRoute('/_authenticated/files/management')({
  pendingComponent: () => (
    <Loader marginTop={3} fillSpace LoaderContainerClasses={{}} />
  ),
  component: TirFilesTable,
});
